import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.5 0.5C6.5 0.223858 6.72386 0 7 0C8.38447 0 9.73785 0.410543 10.889 1.17971C12.0401 1.94888 12.9373 3.04213 13.4672 4.32122C13.997 5.6003 14.1356 7.00777 13.8655 8.36563C13.5954 9.7235 12.9287 10.9708 11.9497 11.9497C10.9708 12.9287 9.7235 13.5954 8.36563 13.8655C7.00777 14.1356 5.6003 13.997 4.32122 13.4672C3.04213 12.9373 1.94888 12.0401 1.17971 10.889C0.410543 9.73785 0 8.38447 0 7C0 6.86739 0.0526784 6.74021 0.146447 6.64645C0.240215 6.55268 0.367392 6.5 0.5 6.5H6.5V0.5ZM3.1109 2.05024C2.818 1.75734 2.34313 1.75734 2.05024 2.05024C1.75734 2.34313 1.75734 2.818 2.05024 3.1109L2.9109 3.97156C3.20379 4.26445 3.67866 4.26445 3.97156 3.97156C4.26445 3.67866 4.26445 3.20379 3.97156 2.9109L3.1109 2.05024Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }